import { CSection } from "../../style/main/main";
import { renderParagraphs } from "../../util/util";
import MainData from "../../view/main/main.data.json";

const CenterSection = () => {
  const data = MainData.mainInfoCards;
  return (
    <CSection>
      <div className="inner">
        <div className="txt">
          <p>
            “스피드 백업“은 중소기업
            <br /> 비즈니스 환경에
          </p>
          <p>
            최적화된 <br /> 클라우드 보안 백업 서비스 입니다.
          </p>
        </div>

        <div className="advantage">
          {data.map((item, index) => (
            <div key={index} className="item-box">
              <div className="img-box">
                <img src={item.image} alt={item.title} className="" />
              </div>
              <div className="txt-box">
                <div className="title">{renderParagraphs(item.title)}</div>
                <div className="paragraphs-box">
                  {renderParagraphs(item.description)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </CSection>
  );
};

export default CenterSection;
